export default __webpack_public_path__ + "static/media/colorYourExperience.474b02d6.png";